import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_DEPARTMENTS_LIST_ID");

const expand = "expand=fields";

export class DepartmentService {
  static async getList() {
    const url = `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}`;
    return api
      .get(getURL(url))
      .then((res) => {
        return res?.data?.value.map((item: any) => DepartmentService.mapData(item));
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async get(id: any) {
    const url = `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&filter=fields/id eq ${id}`;
    return api
      .get(getURL(url))
      .then((res) => {
        if (res.data.length > 0) return DepartmentService.mapData(res.data[0]);
        return null;
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async create(fields: any) {
    return api
      .post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), { fields })
      .then((res) => this.mapData(res.data))
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async update(id: any, fields: any) {
    return api
      .patch(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`), fields)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async delete(id: any, listId?: string) {
    return api
      .delete(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}`))
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static mapData(item: any) {
    return {
      Id: item.id,
      Name: item.fields.Title,
      Abbr: item.fields.Abbr,
      DeptCode: item.fields.DeptCode,
      Status: item.fields.Status,
      CompanyId: item.fields.CompanyLookupId,
      CompanyName: item.fields.Company,
      value: item.id,
      label: item.fields.Title,
      key: item.fields.id,
      docType: item.fields.docType ? JSON.parse(item.fields.docType) : [],
    };
  }
}
